import React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

import styles from './DropDownCmp.module.css'
import { Controller } from 'react-hook-form'

const DropDownCmp = ({
    options,
    label,
    style,
    onChange,
    control,
    name,
    placeholder,
    multiple,
    rules,
    requiredAsterisk,
    ...props
}) => {
    // Create label with required asterisk if needed
    const renderLabel = () => {
        if (requiredAsterisk && label) {
            return (
                <span>
                    {label}
                    <span className={styles.requiredAsterisk}> *</span>
                </span>
            );
        }
        return label;
    };

    return (
        <>
            <Controller
                name={name}
                control={control}
                rules={rules}
                defaultValue={multiple === true ? [] : ''}
                render={({
                    field: { onChange, value, onBlur, ref },
                    fieldState: { error },
                }) => (
                    <Autocomplete
                        freeSolo
                        sx={{ flexGrow: 'grow !important', ...style }}
                        className={styles.selectBox}
                        options={options ? options : list}
                        isOptionEqualToValue={(option, value) => {
                            return (
                                value === undefined ||
                                value === '' ||
                                option.id === value.id ||
                                option.label === value ||
                                option.id === value
                            )
                        }}
                        value={value}
                        onChange={(event, newValue) => {
                            onChange(newValue)
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={renderLabel()}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={!!error}
                                helperText={error ? error.message : null}
                                onBlur={onBlur}
                                inputRef={ref}
                                placeholder={placeholder && placeholder}
                                required={props.required}
                            />
                        )}
                        multiple={multiple}
                        {...props}
                    />
                )}
            />
        </>
    )
}

const list = [
    'The Shawshank Redemption',
    'The Godfather',
    'The Godfather: Part II',
    'The Dark Knight',
    '12 Angry Men',
    "Schindler's List",
    'Pulp Fiction',
]

export default DropDownCmp
